import { getObject } from './getObject';
import { putObject } from './putObject';
import { upload } from './upload';

export { putObject, upload, getObject };

export default { putObject, upload, getObject };
